import { tv } from "../../variants/tv.js";
const createLogoSize = (height, heightToken, maxWidth = true)=>({
        height,
        heightToken,
        width: 'auto',
        maxWidthMultiplier: 5,
        maxWidth: maxWidth ? `calc(${height}px * 5)` : 'auto',
        clearSpaceMultiplier: 0.5,
        clearSpace: `calc(${height}px * 0.5)`
    });
const logoConfig = {
    xs: createLogoSize(16, 'h-4'),
    sm: createLogoSize(24, 'h-6'),
    md: createLogoSize(32, 'h-8'),
    lg: createLogoSize(48, 'h-12'),
    xl: createLogoSize(64, 'h-16'),
    body1: createLogoSize(16, 'h-[16px]', false),
    body2: createLogoSize(14, 'h-[14px]', false),
    body3: createLogoSize(12, 'h-[12px]', false),
    heading1: createLogoSize(40, 'h-[40px]', false),
    heading2: createLogoSize(32, 'h-[32px]', false),
    heading3: createLogoSize(26, 'h-[26px]', false),
    heading4: createLogoSize(20, 'h-[20px]', false),
    heading5: createLogoSize(16, 'h-[16px]', false),
    heading6: createLogoSize(14, 'h-[14px]', false),
    subheading1: createLogoSize(26, 'h-[26px]', false),
    subheading2: createLogoSize(20, 'h-[20px]', false),
    subheading3: createLogoSize(16, 'h-[16px]', false),
    subheading4: createLogoSize(14, 'h-[14px]', false)
};
const logoImgLabelTextStyleBySize = {
    xs: 'body3',
    sm: 'body3',
    md: 'body3',
    lg: 'body2',
    xl: 'body1',
    body1: 'body1',
    body2: 'body2',
    body3: 'body3',
    heading1: 'heading1',
    heading2: 'heading2',
    heading3: 'heading3',
    heading4: 'heading4',
    heading5: 'heading5',
    heading6: 'heading6',
    subheading1: 'subheading1',
    subheading2: 'subheading2',
    subheading3: 'subheading3',
    subheading4: 'subheading4'
};
const logoImgLabelRowVariants = tv({
    base: 'inline-flex flex-row items-center',
    variants: {
        size: {
            xs: 'gap-2',
            sm: 'gap-2',
            md: 'gap-3',
            lg: 'gap-4',
            xl: 'gap-6',
            body1: 'gap-2',
            body2: 'gap-2',
            body3: 'gap-2',
            heading1: 'gap-4',
            heading2: 'gap-4',
            heading3: 'gap-4',
            heading4: 'gap-4',
            heading5: 'gap-4',
            heading6: 'gap-4',
            subheading1: 'gap-4',
            subheading2: 'gap-4',
            subheading3: 'gap-4',
            subheading4: 'gap-4'
        },
        display: {
            inline: 'justify-center',
            topLeft: 'justify-start'
        }
    },
    defaultVariants: {
        size: 'md',
        display: 'inline'
    }
});
const logoImgVariants = tv({
    slots: {
        wrapper: 'inline-flex',
        img: ''
    },
    variants: {
        size: {
            xs: {
                img: 'h-4'
            },
            sm: {
                img: 'h-6'
            },
            md: {
                img: 'h-8'
            },
            lg: {
                img: 'h-12'
            },
            xl: {
                img: 'h-16'
            },
            body1: {
                img: 'h-[16px]'
            },
            body2: {
                img: 'h-[14px]'
            },
            body3: {
                img: 'h-[12px]'
            },
            heading1: {
                img: 'h-[40px]'
            },
            heading2: {
                img: 'h-[32px]'
            },
            heading3: {
                img: 'h-[26px]'
            },
            heading4: {
                img: 'h-[20px]'
            },
            heading5: {
                img: 'h-[16px]'
            },
            heading6: {
                img: 'h-[14px]'
            },
            subheading1: {
                img: 'h-[26px]'
            },
            subheading2: {
                img: 'h-[20px]'
            },
            subheading3: {
                img: 'h-[16px]'
            },
            subheading4: {
                img: 'h-[14px]'
            }
        },
        emphasis: {
            regular: {
                wrapper: 'bg-transparent'
            },
            medium: {
                wrapper: 'bg-neutral-1/70 backdrop-blur-sm'
            },
            bold: {
                wrapper: 'bg-neutral-12/50 backdrop-blur-md'
            }
        },
        display: {
            inline: {},
            topLeft: {}
        },
        clearSpace: {
            true: {},
            false: {}
        },
        colorMode: {
            original: {},
            white: {
                img: 'brightness-0 invert'
            },
            black: {
                img: 'brightness-0'
            }
        }
    },
    compoundVariants: [
        {
            clearSpace: true,
            display: 'inline',
            class: {
                wrapper: 'items-center justify-center rounded-xl'
            }
        },
        {
            clearSpace: true,
            display: 'topLeft',
            class: {
                wrapper: 'items-start justify-start rounded-tl-xl rounded-br-xl'
            }
        }
    ],
    defaultVariants: {
        size: 'md',
        emphasis: 'regular',
        display: 'inline',
        clearSpace: false,
        colorMode: 'original'
    }
});
const logoSizes = Object.keys(logoConfig);
export { logoConfig, logoImgLabelRowVariants, logoImgLabelTextStyleBySize, logoImgVariants, logoSizes };
